import { Grid, Box, Typography, styled } from '@mui/material';
import { lightPalette, up } from '../../../../theme';
import backgroundImg from '../../../../assets/common-assets/authentication-background-img.png';

export const classes = {
  root: 'root',
  leftGrid: 'left-grid',
  leftGridInnerBox: 'left-grid-inner-box',
  leftBoxSubtitle: 'left-box-subtitle',
  carouselGridTail: 'carouselGridTail',
  carouselLeftGridInnerBox: 'carouselLeftGridInnerBox',
  blogCarouselBox: 'blogCarouselBox',
  blogCard: 'blogCard',
  blogCardContent: 'blogCardContent',
  blogCardContentBox: 'blogCardContentBox',
  blogTextBox: 'blogTextBox',
  blogProfileMainBox: 'blogProfileMainBox',
  avatarStyle: 'avatarStyle',
  profileDetails: 'profileDetails',
  profileName: 'profileName',
  paginationDotBox: 'paginationDotBox',
};

export const LeftGridItem = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundImage: `url(${backgroundImg})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  [up('xs')]: {
    backgroundSize: '200%',
  },
  [up('sm')]: {
    backgroundSize: 'cover',
  },
}));

export const GridMainInnerBox = styled(Box)(() => ({
  width: '50%',
}));

export const TypographyTitle = styled(Typography)(() => ({
  fontWeight: '700',
  fontFamily: 'Poppins',
  letterSpacing: 0,
  [up('xs')]: {
    fontSize: '24px',
  },
  [up('sm')]: {
    fontSize: '30px',
  },
  [up('md')]: {
    fontSize: '36px',
    lineHeight: 1,
  },
  [up('lg')]: {
    fontSize: '44px',
  },
  [up('xl')]: {
    fontSize: '56px',
  },
  [up('xxl')]: {
    fontSize: '64px',
  },
}));

export const TypographySubtitle = styled(Typography)(() => ({
  width: '92.5%',
  lineHeight: '1.5',
  [up('xs')]: {
    display: 'none',
  },
  [up('sm')]: {
    display: 'block',
    marginTop: '10px',
  },
  [up('md')]: {
    marginTop: '12px',
  },
  [up('lg')]: {
    marginTop: '17px',
  },
  [up('xl')]: {
    marginTop: '22px',
  },
  [up('xxl')]: {
    marginTop: '27px',
  },
}));

export const CarouselGridItem = styled(Grid)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  [up('xs')]: {
    height: '40vh',
    padding: '0px 25px',
  },
  [up('sm')]: {
    height: '100vh',

    padding: '25px',
  },
  [`& .${classes.carouselGridTail}`]: {
    fontFamily: 'Poppins',
    fontWeight: '600',
    letterSpacing: 0,
    [up('xs')]: {
      fontSize: '24px',
    },
    [up('sm')]: {
      fontSize: '30px',
    },
    [up('md')]: {
      fontSize: '36px',
    },
    [up('lg')]: {
      fontSize: '44px',
    },
    [up('xl')]: {
      fontSize: '56px',
    },
    [up('xxl')]: {
      fontSize: '64px',
    },
  },
  [`& .${classes.carouselLeftGridInnerBox}`]: {
    [up('xs')]: {
      padding: '10px 20px',
    },
    [up('md')]: {
      padding: '35px 35px 0px',
    },
  },
  [`& .${classes.leftBoxSubtitle}`]: {
    marginTop: '20px',
  },
  [`& .${classes.blogCarouselBox}`]: {
    [up('xs')]: {
      display: 'none',
      padding: '0px 10px 20px',
    },
    [up('sm')]: {
      display: 'block',
    },
    [up('md')]: {
      padding: '0px 35px 20px',
    },
  },
  [`& .${classes.blogCard}`]: {
    transition: 'transform 0.3s ease',
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    [up('xs')]: {
      height: '320px',
    },
    [up('sm')]: {
      height: '220px',
    },
  },
  [`& .${classes.blogCardContent}`]: {
    height: '100%',
  },
  [`& .${classes.blogCardContentBox}`]: {
    [up('xs')]: {
      padding: '0px',
    },
    [up('md')]: {
      padding: '10px',
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  [`& .${classes.blogTextBox}`]: {
    paddingTop: '6px',
  },
  [`& .${classes.blogProfileMainBox}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${classes.avatarStyle}`]: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    border: '1px solid #fff',
  },
  [`& .${classes.profileDetails}`]: {
    color: lightPalette.secondaryWhite.main,
    marginLeft: '10px',
    fontSize: '10px',
    fontWeight: 400,
  },
  [`& .${classes.profileName}`]: {
    fontSize: '12px',
    fontWeight: 500,
    color: lightPalette.secondaryWhite.main,
  },
  [`& .${classes.paginationDotBox}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '16px',
  },
}));

export const CarouselGridMainInnerBox = styled(Box)(() => ({
  width: '100%',
  [up('sm')]: {
    height: '100%',
  },
  backgroundColor: '#2B1E59',
  borderRadius: '10px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
}));

// blog carousel
export const CarouselContainer = styled(Box)(() => ({
  position: 'relative',
  width: '100%',
  overflow: 'hidden',
  padding: '32px 0 0',
}));

export const CarouselWrapper = styled(Box)(() => ({
  display: 'flex',
  transition: 'transform 0.5s ease',
  width: '100%',
}));

export const PaginationDot = styled(Box)(({ active }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  backgroundColor: active
    ? 'rgba(159, 119, 235, 1)'
    : 'rgba(255, 255, 255, 0.1)',
  margin: '0 4px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
}));
